export default __webpack_public_path__ + "static/media/D_Dente.ff7a4c5f.svg";